module.exports = __webpack_public_path__ + "img/leftArrow.ece4d95d.svg";